module.exports = __webpack_public_path__ + "img/omega-1-empatico.d07b45a3.png";